<template>
  <building-blank-form
    submit-label="Добавить дом"
    :building="building"
    :errors="errors"
    form-type="add"
    @submit="processBuildingForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { addBuilding } from '@/services/building.service'
import buildingBlankForm from '@/components/forms/building/BuildingBlankForm'

export default {
  name: 'building-add-form',
  components: { buildingBlankForm },
  props: {
    address: {
      type: [Number]
    }
  },
  data () {
    return {
      building: {
        id: null,
        number: '',
        contract_number_prefixes: '',
        address: this.address
      },

      errors: {
        building: {
          id: [],
          number: [],
          contract_number_prefixes: [],
          address: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processBuildingForm () {
      this.addBuilding().then((success) => {
        if (success) {
          this.showMsg('Дом был успешно добавлен!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    addBuilding () {
      return addBuilding(this.building).then((response) => {
        this.building = response.data
        this.fillErrors(this.errors.building, {})
        return true
      }).catch(err => {
        console.log(err.response)
        this.fillErrors(this.errors.building, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BuildingAddForm.vue?7f85292c